module.exports = __webpack_public_path__ + "img/service 2.41d6ced1.png";